const COS = require('cos-js-sdk-v5')

var cos = new COS({
    SecretId:'AKIDCVo3Mi7Nery9FFEf3Y5iNHIG6DLYsMyd',
    SecretKey:'vtvwu1454HUdHxa3V473z5BFPfDpP1gI',
})

export {cos}
